import { featureItems } from "@/mocks/homeData";

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            为什么选择黄桃视频
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            三大核心优势，打造超越91视频和97视频的高清流畅播放体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {featureItems.map((item, i) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-2xl p-8 text-center border border-background-200/60 hover:border-primary-200 transition-all group cursor-default"
            >
              <div className={`w-16 h-16 mx-auto mb-5 rounded-2xl flex items-center justify-center ${
                i === 0 ? "bg-accent-100" : i === 1 ? "bg-primary-100" : "bg-secondary-100"
              }`}>
                <i className={`${item.icon} text-2xl ${
                  i === 0 ? "text-accent-600" : i === 1 ? "text-primary-600" : "text-secondary-600"
                }`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-900 mb-3 font-heading">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}